import { CircleIndicator } from 'Components/Indicator/CircleIndicator';
import { Text } from 'Components/Text/Text';
import { Effectiveness, effectivenessAsString, getEffectivenessVariantColor } from 'Models/OperationalControls';

import styles from './CircleIndicatorRiskRating.module.css';

interface CircleIndicatorControlEffectivenessProps {
    /** If undefined, `Effectiveness.UNRATED` is used. */
    effectiveness?: Effectiveness;
    /** If undefined, 'standard' is used. */
    pageVariant?: 'standard' | 'dashboard';
}

// TODO: Consider updating this component to also accommodate displaying decimals (averages). If this is done, replace all remaining instances of `CircleIndicator` used in conjunction with `getEffectivenessVariantColor`.
/** Renders a colored circle, where the color corresponds with the given effectiveness, next to the user-friendly name for the effectiveness. */
export const CircleIndicatorControlEffectiveness = (props: CircleIndicatorControlEffectivenessProps) => {
    const effectiveness = props.effectiveness ?? Effectiveness.UNRATED;
    const pageVariant = props.pageVariant ?? 'standard';

    return (
        <div className={styles.circleAndTextContainer}>
            <CircleIndicator variant={getEffectivenessVariantColor(effectiveness)} />
            <Text noStyles color={pageVariant === 'standard' ? 'blue' : 'white'}>
                {effectivenessAsString(effectiveness)}
            </Text>
        </div>
    );
};
